<template>
    <!-- 遮罩层 -->
    <div class="exam_seat_detail_page">
        <div class="exac_title" v-if="orderData">
            {{
                currentLocale === "zh-CN"
                    ? orderData.examTitle
                    : orderData.examTitleEn
            }}
        </div>
        <!-- 考期规则 -->
        <div style="" class="personal_info_section_box">
            <div class="personal_info_section">
                <div class="action_buttons">
                    <p class="info">{{ $t("payment.personTitle") }}</p>
                    <p class="edit_info_btn">
                        <span style="color: red">*</span>
                        {{
                            currentLocale === "zh-CN"
                                ? "温馨提示：若需要修改报名信息，请联系牛津考小助手。"
                                : "Reminder: If you need to update your registration information, please contact the Customer Service."
                        }}
                    </p>
                </div>
                <!-- 表格主体 -->
                <div class="info_table">
                    <div class="table_row row-col1">
                        <div class="table_cell table_cell_label">
                            {{ $t("studentInfo.credentialType") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ getCredentialTypeName(orderData.credentialType) }}
                        </div>
                    </div>
                    <div class="table_row row-col1">
                        <div class="table_cell table_cell_label">
                            {{ $t("studentInfo.document") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.passport }}
                        </div>
                    </div>
                    <div class="table_row row-col1">
                        <div class="table_cell table_cell_label">
                            {{ $t("studentInfo.weChatID") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.WeChat }}
                        </div>
                    </div>
                    <div class="table_row row-col1">
                        <div class="table_cell table_cell_label">
                            {{ $t("payment.lastName") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.lastName }}
                        </div>
                    </div>
                    <div class="table_row row-col2">
                        <div class="table_cell table_cell_label">
                            {{ $t("payment.firstName") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.firstName }}
                        </div>
                    </div>
                    <div class="table_row row-col2">
                        <div class="table_cell table_cell_label">
                            {{ $t("payment.lastNamePy") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.lastNamePy }}
                        </div>
                    </div>
                    <div class="table_row row-col2">
                        <div class="table_cell table_cell_label">
                            {{ $t("payment.firstNamePy") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.firstNamePy }}
                        </div>
                    </div>
                    <div class="table_row row-col2">
                        <div class="table_cell table_cell_label">
                            {{ $t("payment.email") }}：
                        </div>
                        <div class="table_cell table_cell_value">
                            {{ orderData.email }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="personal_info_section">
                <div class="action_buttons">
                    <p class="info">
                        {{
                            currentLocale === "zh-CN"
                                ? "已选考位"
                                : "Selected Test Slot"
                        }}
                    </p>
                </div>
                <!-- 表格主体 -->
                <div class="exam_info">
                    <div class="section_header">
                        <h2 class="section_title">
                            {{ selectedExamDateText }}
                        </h2>
                        <div class="exam_type_tag">
                            {{
                                currentLocale === "zh-CN"
                                    ? "线下机考"
                                    : "In-Person Computer-Based"
                            }}
                        </div>
                    </div>
                    <div class="section_detail">
                        <div class="item_detail">
                            <p>
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/定位.png" alt="" />
                                {{
                                currentLocale === "zh-CN"
                                    ? "考试地点"
                                    : "Test Venue"
                                }}：
                                {{ selectedExamDateText1 }}
                            </p>
                            <p>
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时间.png" alt="" />{{
                                    selectedDeadlineText
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 个人信息 -->

        <div class="personal_button">
            <p @click="withdrawalExam" v-if="buttonData.showQuit">{{ $t("changeSeat.cancel") }}</p>
            <p @click="reExam" v-if="buttonData.showTransfer">{{ $t("changeSeat.reselect") }}</p>
        </div>
        <!-- 申请退考 -->
        <Modal
            :showModal="showQuitDialog"
            :show-default-content="false"
            :show-default-tips="false"
            :show-delete-icon="true"
            :title="$t('changeSeat.cancel')"
            @confirm="submitQuit"
            @cancel="closeQuitDilog"
        >
            <template #content>
                <div class="re_pay_content">
                    <div class="re_pay_title">
                        <p>
                            {{
                                currentLocale === "zh-CN"
                                    ? "温馨提示"
                                    : "Please Note"
                            }}：
                        </p>
                        <p v-if="backOrderDetail.fee">
                           	{{currentLocale === 'zh-CN' ? `您正在申请退考，根据退款规则，系统审核通过后，考试费将扣除 ${backOrderDetail.fee} 元手续费，剩余部分将原路退还。` :`You are applying for a test cancellation. As the exam date is approaching, after system approval, a processing fee of  ${backOrderDetail.fee} RMB will be deducted from the test fee, and the remaining amount will be refunded to the original payment method.`}}
                        </p>
                        <p v-else>
                            {{
                                currentLocale === "zh-CN"
                                    ? "您正在申请退考，我们将在确认您符合退款条件后，将您的款项原路退回。"
                                    : `You are requesting test cancellation. Upon confirming your eligibility for a refund, the payment will be returned to your original payment method.`
                            }}
                        </p>
                    </div>
                    <div class="re_pay_reason">
                        <el-select
                            v-model="quitId"
                            popper-class="custom-select-dropdown"
                            :placeholder="
                                currentLocale === 'zh-CN'
                                    ? '请选择退考原因'
                                    : 'Select a Reason for Cancellation'
                            "
                        >
                            <el-option
                                v-for="item in quitReasonList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-input
                            type="textarea"
                            :rows="4"
                            v-if="quitId === 7"
                            v-model="quitText"
                            :placeholder="
                                currentLocale === 'zh-CN'
                                    ? '请填写具体情况'
                                    : 'Please provide specific information'
                            "
                        ></el-input>
                    </div>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
        <!-- 重选考位 -->
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            :show-delete-icon="true"
            show-size="big"
            @confirm="showModal = false"
            @cancel="showModal = false"
        >
            <template #content>
                <examSeatModal :orderData="orderData" @sureReat="reatConfirm" />
            </template>
            <template #footer>
                <!-- <button class="btn-submit" @click="submitCustom">提交申请</button> -->
            </template>
        </Modal>
    </div>
</template>

<script>
import {
    getOrderDetailRescource,
    isBackOrderDetail,
    isReselectPosition,
    backOrder,
    getButtonStatus
} from "@/plugins/api";
import { toCST, formatChinese, formatChineseNoYear, formatEnglish, formatEnglishFull, getYear } from "@/utils/date";

import examSeatModal from "@/components/examSeatModal.vue";
export default {
    name: "examSeatDetailModal",
    components: { examSeatModal },
    props: {
        orderId: {
            default: ""
        },
    },
    data() {
        return {
            showModal: false,
            status: "查看考位 ",
            value: null, // 地址下拉选中值
            year: null, // 年份下拉选中值
            selected: "",
            deraction: "bottom",
            navHeight: 0,
            examDate: "2025-04-14", // 考试日期（示例数据，实际应从接口获取）
            cancelMessage: "", // 退考提示信息
            showCancelPopup: false, // 是否显示退考弹窗
            popupType: "info", // 弹窗类型（用于切换图标）,
            orderId: "", // 订单ID
            orderData: {}, // 订单详情数据
            currentLocale: "zh-CN", // 当前语言
            showBottomBtn: true, // 控制底部按钮显示
            popupStatus: null,
            reselectErrorMsgZh: "",
            reselectErrorMsgEn: "",
            showQuitDialog: false, // 控制新弹窗显示
            quitId: null, // 退考原因编号
            quitText: "", // 具体情况
            isCancelRefund: false,
            credentialTypeMap: {
                '0': '中华人民共和国护照',
                '1': '居民身份证',
                '2': '香港永久性居民身份证',
                '3': '澳门永久性居民身份证',
                '4': '港澳居民居住证',
                '5': '中国香港护照',
                '6': '中国澳门护照',
                '7': '台湾居民来往大陆通行证',
                '8': '台湾居民居住证',
                '9': '外籍人士有效护照',
                '10': '外国人永久居留身份证'
            },
            buttonData: null,
            backOrderDetail: null
        };
    },
    computed: {
        selectedPositionText() {
            if (
                !this.orderData ||
                !this.orderData.positionInfo ||
                !this.orderData.positionInfo.exam_point
            )
                return "";
            return this.currentLocale === "zh-CN"
                ? this.orderData.positionInfo.exam_point.name
                : this.orderData.positionInfo.exam_point.nameEn;
        },
        selectedYearText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const year = getYear(this.orderData.positionInfo.examTime);
            return this.currentLocale === "zh-CN" ? `${year}年` : `${year}`;
        },
        // 动态考点下拉数据
        selectedRange() {
            if (!this.orderData || !this.orderData.positionInfo) return [];
            return [
                {
                    value: 0,
                    text:
                        this.currentLocale === "zh-CN"
                            ? this.orderData.positionInfo.position
                            : this.orderData.positionInfo.positionEn,
                },
            ];
        },
        // 动态年份下拉数据
        selectedYearList() {
            if (!this.orderData || !this.orderData.positionInfo) return [];
            const year = getYear(this.orderData.positionInfo.examTime);
            return [
                {
                    value: year,
                    text:
                        this.currentLocale === "zh-CN"
                            ? `${year}年`
                            : `${year}`,
                },
            ];
        },
        // 动态考试日期
        selectedExamDateText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const examTime = this.orderData.positionInfo.examTime;
            return this.currentLocale === "zh-CN"
                ? `${formatChinese(examTime)} ${this.orderData.positionInfo.sessions}`
                : `${formatEnglish(examTime)} ${this.orderData.positionInfo.sessions}`;
        },
        selectedExamDateText1() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const exam_point = this.orderData.positionInfo.exam_point
                ? this.orderData.positionInfo.exam_point
                : "";
            return this.currentLocale === "zh-CN"
                ? exam_point.name
                : exam_point.nameEn;
            // return this.currentLocale === "zh-CN"
            //     ? this.orderData.positionInfo.sessions
            //     : this.orderData.positionInfo.sessionsEn;
        },
        // 动态截止日期
        selectedDeadlineText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const deadlineTime = this.orderData.positionInfo.deadlineTime;
            return this.currentLocale === "zh-CN"
                ? `报名截止时间：${formatChineseNoYear(deadlineTime)}`
                : `registration deadline: ${formatEnglish(deadlineTime)}`;
        },
        quitReasonList() {
            if (this.currentLocale === "zh-CN") {
                return [
                    {
                        value: 1,
                        text: "个人突发状况（突发疾病/意外受伤/家庭原因等）",
                    },
                    {
                        value: 2,
                        text: "考试安排冲突（与其他重要考试或学校/工作临时安排冲突）",
                    },
                    {
                        value: 3,
                        text: "考试组织方原因（考试中心取消考试/考试延期且新时间与个人安排冲突/考试系统技术故障）",
                    },
                    {
                        value: 4,
                        text: "个人计划变更，无需该考试成绩或选择其他类似考试",
                    },
                    {
                        value: 5,
                        text: "报名信息错误",
                    },
                    {
                        value: 6,
                        text: "不可抗力原因（自然灾害影响/突发公共卫生事件等）",
                    },
                    {
                        value: 7,
                        text: "其他特殊情况（请填写具体情况）",
                    },
                ];
            } else {
                return [
                    {
                        value: 1,
                        text: "Personal emergency situations (sudden illness / accidental injury / family reasons, etc.)",
                    },
                    {
                        value: 2,
                        text: "Conflict with test arrangements (conflict with other important exams or temporary arrangements at school / workplace)",
                    },
                    {
                        value: 3,
                        text: "Reasons attributable to OTE organizer (cancellation initiated by Test Center / test postponement with the new time conflicting with my personal arrangements / technical failure of OTE system)",
                    },
                    {
                        value: 4,
                        text: "Change in personal plans, no longer needing the test results or switch to other similar exams",
                    },
                    {
                        value: 5,
                        text: "Errors in registration information",
                    },
                    {
                        value: 6,
                        text: "Force majeure factors (impact of natural disasters / sudden public health incidents, etc.)",
                    },
                    {
                        value: 7,
                        text: "Other special circumstances (please specify)",
                    },
                ];
            }
        },
    },
    watch: {
        initialCaseDetails(newVal) {
            this.caseDetails = newVal;
        },
        showModal(newVal) {
            this.showModal = newVal;
        },
        // orderId(newVal) {
        //     this.getOrderDetail(newVal);
        // },
        orderId: {
            immediate: true, // 立即执行一次
            handler(newVal, oldVal) {
                this.orderId = newVal;
                this.getOrderDetail(newVal);
                this.getButtonStatus(newVal)
            },
        },
        "$i18n.locale": {
            handler(newVal) {
                // console.log('语言变化:', newVal);
                this.currentLocale = newVal || "zh-CN";
                // 如果弹窗是打开的，且有popupStatus，重新设置cancelMessage
                if (this.$refs.popupCenter && this.popupStatus) {
                    this.setCancelMessage();
                }
            },
            immediate: true,
        },
    },
    created() {
        this.currentLocale = this.$i18n.locale || "zh-CN";
    },
    methods: {
        async getOrderDetail() {
            let loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const res = await getOrderDetailRescource(this.orderId);
            if (res) {
                this.orderData = res;
                // 地址下拉只有一个，value为0
                this.value = 0;
                // 年份下拉只有一个，value为年份
                if (res.positionInfo) {
                    this.year = getYear(res.positionInfo.examTime);
                }
                const now = toCST(Date.now()).valueOf();
                const examTime = toCST(
                    res.positionInfo.examTime || res.examTime
                ).valueOf();
                this.showBottomBtn = now <= examTime;
            }
            loading.close();
        },
        async getButtonStatus(orderId) { 
           const res = await getButtonStatus (orderId)
           this.buttonData =res
        },
        async handleCancelExam() {
            try {
                // await isBackOrderDetail(this.orderId);
                const res = await isBackOrderDetail(this.orderId);
				this.backOrderDetail = res
                // 可以退考，弹出新弹窗
                this.quitId = null;
                this.quitText = "";
                this.showQuitDialog = true;
            } catch (err) {
                let zh = "",
                    en = "";
                if (err && err.data && err.data.error) {
                    zh =
                        err.data.error.returnUserMessage ||
                        err.data.error.returnMessage ||
                        "操作失败";
                    en =
                        err.data.error.returnUserMessageEn ||
                        err.data.error.returnMessageEn ||
                        "Operation failed";
                } else if (err && err.errMsg) {
                    zh = "网络错误";
                    en = "Network error";
                } else {
                    zh = "未知错误";
                    en = "Unknown error";
                }
                this.$message({
                    message: this.currentLocale === "zh-CN" ? zh : en,
                    type: "success",
                });
                return;
            }
        },
        setCancelMessage() {
            if (
                this.popupStatus === "expired" ||
                this.popupStatus === "canCancel"
            ) {
                this.cancelMessage =
                    this.currentLocale === "zh-CN"
                        ? "温馨提示：\n您好，请添加牛津考小助手企业微信为您办理退考事宜。"
                        : "Friendly Reminder:\nPlease add the Customer Service on WeCom to proceed with the cancellation process.";
            } else if (this.popupStatus === "cannotCancel") {
                this.cancelMessage =
                    this.currentLocale === "zh-CN"
                        ? "温馨提示：\n您好，距离考试日期已不足8天，您无法申请退考。"
                        : "Friendly Reminder:\nThe test date is less than 8 days away. You can no longer request a cancellation.";
            } else if (this.popupStatus === "reselectError") {
                this.cancelMessage =
                    this.currentLocale === "zh-CN"
                        ? this.reselectErrorMsgZh
                        : this.reselectErrorMsgEn;
            }
        },
        getDescList(examInfo) {
            if (!examInfo) return [];
            const desc =
                this.currentLocale === "zh-CN"
                    ? examInfo.desc
                    : examInfo.descEn;
            return desc ? desc.split("\n").filter((item) => item.trim()) : [];
        },
        handleClosePopup() {
            this.$refs.popupCenter.close();
        },
        onQuitReasonChange(e) {
            this.quitId = Number(e);
            if (this.quitId !== 7) this.quitText = "";
        },
        async submitQuit() {
            if (!this.quitId) {
                this.$message({
                    message:
                        this.currentLocale === "zh-CN"
                            ? "请选择退考原因"
                            : "Please select the reason for withdrawal from the exam",
                    type: "warning",
                });
                return;
            }
            if (this.quitId === 7 && !this.quitText.trim()) {
                this.$message({
                    message:
                        this.currentLocale === "zh-CN"
                            ? "请填写具体情况"
                            : "Please provide specific information",
                    type: "warning",
                });
                return;
            }
            try {
                await backOrder({
                    id: this.orderId,
                    quitId: this.quitId,
                    quitText: this.quitId === 7 ? this.quitText : "",
                });
                this.showQuitDialog = false;
                this.$emit("closeModal", false);
                this.$message({
                    message:
                        this.currentLocale === "zh-CN"
                            ? "退考申请已提交"
                            : "The withdrawal application has been submitted",
                    type: "success",
                });
            } catch (err) {
                let zh = "",
                    en = "";
                if (err && err.data && err.data.error) {
                    zh =
                        err.data.error.returnUserMessage ||
                        err.data.error.returnMessage ||
                        "操作失败";
                    en =
                        err.data.error.returnUserMessageEn ||
                        err.data.error.returnMessageEn ||
                        "Operation failed";
                } else if (err && err.errMsg) {
                    zh = "网络错误";
                    en = "Network error";
                } else {
                    zh = "未知错误";
                    en = "Unknown error";
                }
                this.$message({
                    message: this.currentLocale === "zh-CN" ? zh : en,
                    type: "success",
                });
            }
        },
        closeQuitDilog() {
            this.showQuitDialog = false;
        },
        // 确认事件
        reatConfirm(result) {
            this.showModal = result;
            this.$emit("closeModal", false);
        },
        withdrawalExam() {
            this.handleCancelExam();
        },
        reExam() {
            isReselectPosition(this.orderId).then(res=>{
                this.showModal = true;
            })
        },
        getCredentialTypeName(type) {
            const typeMap = {
                '0': 'passport',
                '1': 'IDCard',
                '2': 'passport1',
                '3': 'passport2',
                '4': 'passport3',
                '5': 'passport4',
                '6': 'passport5',
                '7': 'passport6',
                '8': 'passport7',
                '9': 'passport8',
                '10': 'passport9'
            };
            const key = typeMap[type] || 'IDCard';
            return this.$t(`studentInfo.${key}`);
        },
    },
};
</script>

<style lang="stylus" scoped>
.exam_seat_detail_page {
    font-family: 'Microsoft YaHei', sans-serif;
    color: #333;
    max-width: 1200px;
    margin: 0 auto;
    z-index: 1;
    height: 100%;
    overflow: scroll;

    .exac_title {
        font-weight: bold;
        font-size: 26px;
        color: #011E41;

        &:after {
            content: ' ';
            display: block;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
            margin: 12px 0;
        }
    }

    .personal_info_section_box {
        overflow: scroll;
        height: calc(100vh - 420px);
    }

    .personal_info_section {
        .action_buttons {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;

            .info {
                font-size: 20px;
                color: #011E41;
                font-weight: bold;
                display: flex;
                flex-flow: row;
                align-items: center;
                margin-bottom: 1vw;
            }

            .info::before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 22px;
                background: #011E41;
                background-color: $success-color;
                margin-right: 8px;
                background: #011E41;
            }

            .edit_info_btn {
                font-weight: 300;
                font-size: 14px;
                color: #CA0000;
                line-height: 33px;
            }
        }

        .info_table {
            border: 1px solid #9AB0B2;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 20px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-auto-rows: 1fr;

            .table_row {
                display: flex;
                border-bottom: 1px solid #9AB0B2;

                &.row-col1 {
                    border-right: 1px solid #9AB0B2;
                }

                &.row-col1:nth-of-type(1) { grid-column: 1; grid-row: 1; }
                &.row-col1:nth-of-type(2) { grid-column: 1; grid-row: 2; }
                &.row-col1:nth-of-type(3) { grid-column: 1; grid-row: 3; }
                &.row-col1:nth-of-type(4) { grid-column: 1; grid-row: 4; border-bottom: none; }

                &.row-col2:nth-of-type(5) { grid-column: 2; grid-row: 1; }
                &.row-col2:nth-of-type(6) { grid-column: 2; grid-row: 2; }
                &.row-col2:nth-of-type(7) { grid-column: 2; grid-row: 3; }
                &.row-col2:nth-of-type(8) { grid-column: 2; grid-row: 4; border-bottom: none; }

                .table_cell {
                    padding: 16px 12px;
                    font-size: 16px;
                    color: #011E41;

                    &.table_cell_label {
                        width: 120px;
                        flex-shrink: 0;
                        font-weight: 600;
                        color: #606266;
                        border-right: 1px solid #9AB0B2;
                        background-color: #CAD7D8;
                        text-align: left;
                        word-break: break-word;
                    }

                    &.table_cell_value {
                        flex: 1;
                        color: #303133;
                        word-break: break-all;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }

        .exam_info {
            background: #FFFFFF;
            border-radius: 10px;
            border: 1px solid #78A0D0;

            .section_header {
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 16px;
                border-bottom: 1px solid $border-color;
                width: 100%;
                height: 60px;
                background: #011E41;
                border-radius: 10px 10px 0px 0px;
                padding: 18px 20px;

                .section_title {
                    font-weight: bold;
                    font-size: 18px;
                    color: #FFFFFF;
                    line-height: 33px;
                }

                .exam_type_tag {
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    justify-content: center;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                }
            }

            .section_detail {
                padding: 12px 20px;
            }

            .item_detail {
                display: flex;
                flex-flow: column;
                justify-content: center;

                img {
                    width: 18px;
                    // height: 20px;
                    margin-right: 10px;
                }

                p {
                    font-weight: 400;
                    font-size: 18px;
                    color: #011E41;
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    margin-bottom: 6px;
                }
            }
        }
    }

    .personal_button {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-flow: row;
        align-items: flex-end;
        justify-content: flex-end;

        p {
            // width: 150px;
            padding: 0 10px;
            height: 44px;
            border-radius: 22px;
            border: 1px solid #0043E0;
            font-size: 18px;
            color: #FFFFFF;
            background: #0043E0;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: center;
        }

        p:first-child {
            font-weight: 400;
            font-size: 18px;
            color: #0043E0;
            background-color: #fff;
            margin-right: 20px;
        }
    }

    .re_pay_content {
        .re_pay_title {
            p {
                font-weight: 400;
                font-size: 16px;
                color: #011E41;
            }

            p:first-child {
                font-weight: 500;
                font-size: 20px;
                color: #011E41;
            }
        }

        .re_pay_reason {
            margin: 20px 0;

            // .el-select {
            // width: 100%;
            // }
            >>>.el-select {
                width: 100%;
                margin-bottom: 20px;
            }

            >>>.el-textarea__inner {
                background-color: #fafcff;
                border-radius: 10px;
            }
        }
    }
}

@media (max-width: 640px) {
    .custom-select-dropdown {
        .el-scrollbar {
            max-width: 100%;
        }

        .el-select-dropdown__item {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 280px; /* 根据实际宽度调整 */
        }
    }

    .exam_seat_detail_page {
        padding: 0 0;
        .personal_info_section_box {
            overflow: scroll;
            height: calc(100vh - 35vh);
        }

        .exac_title {
            font-size: 5vw;
        }

        .personal_info_section {
            padding: 0;

            .action_buttons {
                .info {
                    font-size: 4vw;
                }

                .info::before {
                    width: 1vw;
                    height: 5vw;
                }

                .edit_info_btn {
                    img {
                        width: 5.8vw;
                        height: 5.8vw;
                    }
                }

                .edit_info_btn {
                    font-size: 2.6vw;
                }
            }

            .info_table {
                display: flex;
                flex-direction: column;

                .table_row {
                    grid-column: auto !important;
                    grid-row: auto !important;
                    border-right: none !important;
                    border-bottom: 1px solid #9AB0B2;

                    &:last-child {
                        border-bottom: none;
                    }

                    .table_cell.table_cell_label {
                        font-size: 3.6vw;
                        padding: 2vw;
                        width: 28vw;
                    }

                    .table_cell.table_cell_value {
                        padding: 2vw;
                        font-size: 3.6vw;
                    }
                }
            }

            .exam_info {
                .section_header {
                    height: 10vw;
                    padding: 2vw;

                    .exam_type_tag {
                        font-size: 3vw;
                    }

                    .section_title {
                        font-size: 3.6vw;
                    }
                }

                .item_detail {
                    img {
                        width: 3vw;
                        margin-right: 1vw;
                    }

                    p {
                        font-size: 3.6vw;
                    }
                }
            }
        }

        .personal_button {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            position: absolute;
            bottom: 1.2vw;
            left: 0;
            z-index: 1;

            p {
                // width: 30vw;
                height: 8vw;
                border-radius: 6vw;
                font-size: 4.4vw;
            }

            p:first-child {
                font-weight: 400;
                color: #0043E0;
                background-color: #fff;
                margin-right: 4vw;
            }
        }

        .re_pay_content {
            .re_pay_title {
                p {
                    font-size: 4vw;
                }

                p:first-child {
                    font-size: 4.5vw;
                }
            }

            .re_pay_reason {
                margin: 4vw 0;

                >>>.el-select {
                    margin-bottom: 5vw;
                    width: 100%;
                }

                >>>.el-textarea__inner {
                    border-radius: 2vw;
                    border: 1px solid #78a0d0;
                }
            }
        }
    }
}
</style>